<template>
  <div class="quality-inspector-wrapper">
    <z-action-picker
      v-model="showPop"
      title="质检师介绍"
      :show-btn="false"
      height="60vh"
      @close="onClose"
    >
      <div class="item">
        <div class="user-info">
          <div class="pic">
            <img :src="info.icon" />
          </div>
          <div class="name">
            {{ info.omsSceneEngineerTitle }} {{ '  ' }} {{ info.omsSceneEngineerName }}
          </div>
        </div>
        <div class="desc">{{ info.desc }}</div>
      </div>
    </z-action-picker>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { ActionPicker } from '@zz-common/zz-ui'
  Vue.use(ActionPicker)
  export default {
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      info: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        showPop: this.show,
      }
    },
    mounted() {
      console.log('show>>>>>>>>', this.showPop)
    },
    watch: {
      show(n) {
        this.showPop = n
      },
    },
    methods: {
      onClose() {
        console.log('onClose>>>>>>>>')
        this.$emit('update:show', false)
      },
    },
  }
</script>
<style lang="scss">
  .quality-inspector-wrapper {
    max-height: 70vh;
    .z-action-picker__title {
      height: 125px;
      font-family: PingFangSC, PingFang SC;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      .title-text {
        font-size: 40px;
        font-weight: 500;
        color: #111111;
        position: relative;
        top: -16px;
      }
    }
    .z-action-picker__content {
      position: relative;
      top: -42px;
      padding: 0 24px 0 24px;
      .item {
        background: #fafafa
          url(https://pic2.zhuanstatic.com/zhuanzh/32b11403-2c74-4c6c-a6c7-112247eb87c8.png)
          no-repeat 100% 0;
        width: 670px;
        min-height: 384px;
        border-radius: 12px;
        margin: 24px auto;
        padding: 60px 32px;
        box-sizing: border-box;
        .user-info {
          height: 80px;
          display: flex;
          align-content: center;
          .pic {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            margin-right: 28px;
            background: #fff;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .name {
            font-size: 28px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #111111;
            line-height: 34px;
            display: flex;
            align-items: center;
          }
        }
        .desc {
          margin-top: 36px;
          font-size: 24px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 300;
          color: #666666;
          line-height: 40px;
        }
      }
    }
  }
</style>
